import { atom } from 'jotai'

export const maskedAssetsStorageKey = 'zkex_v3_masked_assets'
export const maskedAssetsAtom = atom<boolean>(
  window.localStorage.getItem(maskedAssetsStorageKey) === 'true' || false,
)
